import { FreshworksHelper } from "app/helpers/freshworksHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import isPublicView from "app/utils/publicViewUtils";
import cx from "classnames";
import { useEffect } from "react";
import { injectIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import HelpAndLearningContent from "./components/HelpAndLearningContent/HelpAndLearningContent";
import HelpAndLearningHeader from "./components/HelpAndLearningHeader/HelpAndLearningHeader";
import "./HelpAndLearningScreenDesktop.scss";
import "./HelpAndLearningScreenMobile.scss";
import "./HelpAndLearningScreenTablet.scss";

const HelpAndLearningScreen = (props: {
  history: any;
  showNotificationDisplay: any;
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch.userModel.loadUser();
    return () => {
      if (!isPublicView()) {
        FreshworksHelper.hideWidget();
      }
    };
  }, []);

  return (
    <div
      className={cx("help-and-learning", {
        "help-and-learning--notifications-active":
          props.showNotificationDisplay,
        "help-and-learning-asian": SessionHelper.isAsianRouteAndSessionView(),
      })}
    >
      <HelpAndLearningHeader
        history={props.history}
        id={"account-helpandlearning"}
      />
      <HelpAndLearningContent />
    </div>
  );
};

const mapStateToProps = state => ({
  showNotificationDisplay: state.notificationListModel.showNotificationDisplay,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadUser: () => {
    dispatch.userModel.loadUser();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(HelpAndLearningScreen));
